import axios from 'axios';
import { AMLS_COMMON } from '../pages/constants/globalConstants';
import UserService from './keycloak';
import { getStrategyType } from '../util/localStorageUtils';
import { apiConfig } from './apiConfig';

export function createAxiosServiceInstance(accessToken, timeout) {
  let headers = {
    'Content-Type': 'application/json'
  };
  if (accessToken) {
    headers = {
      ...headers,
      Authorization: `${accessToken}`
    };
  } else {
    const saved_token =
      (localStorage && localStorage.getItem('id_token')) || '';
    const productId = (localStorage && localStorage.getItem('productId')) || '';
    headers = {
      ...headers,
      // Authorization: `${saved_token}`,
      Authorization: `Bearer ${saved_token}`,
      ProductId: productId
    };
  }

  const serviceAxios = axios.create({
    timeout: timeout ?? 200000,
    headers: headers,
    validateStatus: false
  });

  serviceAxios.interceptors.request.use(async (config) => {
    config.baseURL = config.baseURL || apiConfig.serviceApi;
    const strategyType = getStrategyType() || 'hybrid';
    let token = localStorage.getItem('id_token') || '';
    if (token) {
      if (strategyType === 'keycloak') {
        try {
          token = await UserService.updateToken();
        } catch (error) {
          console.warn('Token refresh failed in request interceptor:', error);
          // Don't proceed with the request if token refresh failed
          return Promise.reject({
            ...error,
            isAuthError: true,
            message: 'Authentication token refresh failed'
          });
        }
      }
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  });

  serviceAxios.interceptors.response.use(
    function (response) {
      if (response.status === 401) {
        console.warn('401 Unauthorized response received');
        // Let the application handle 401 errors gracefully instead of immediate logout
        return Promise.reject({
          ...response,
          isAuthError: true,
          message: response.data?.message || 'Authentication required'
        });
      }

      if (response.status === 504) {
        return Promise.reject(response);
      }

      return response;
    },
    function (error) {
      if (error.response?.status === 401 || error.status === 401) {
        console.warn('401 Unauthorized error received');
        // Let the application handle 401 errors gracefully instead of immediate logout
        return Promise.reject({
          ...error,
          isAuthError: true,
          message:
            error.response?.data?.message ||
            error.message ||
            'Authentication required'
        });
      } else {
        return Promise.reject(error);
      }
    }
  );

  return serviceAxios;
}

export function createAxiosAuthInstance(accessToken) {
  let headers = {
    'Content-Type': 'application/json'
    // 'Access-Control-Allow-Origin': '*',
  };
  if (accessToken) {
    headers = {
      ...headers,
      Authorization: `Token ${accessToken}`
    };
  } else {
    const saved_token =
      (localStorage && localStorage.getItem('id_token')) || '';
    headers = {
      ...headers,
      // Authorization: `Token ${saved_token}`
      Authorization: `Bearer ${saved_token}`
    };
  }

  const authAxios = axios.create({
    timeout: 180000,
    headers: headers
  });

  authAxios.interceptors.request.use(async (config) => {
    config.baseURL = `${apiConfig.serviceApi}${AMLS_COMMON}`;
    config.headers = config.headers || { 'Content-Type': 'application/json' };
    const strategyType = getStrategyType() || 'hybrid';
    let token = localStorage.getItem('id_token') || '';
    if (token) {
      if (strategyType === 'keycloak') {
        try {
          token = await UserService.updateToken();
        } catch (error) {
          console.warn(
            'Token refresh failed in auth request interceptor:',
            error
          );
          // Don't proceed with the request if token refresh failed
          return Promise.reject({
            ...error,
            isAuthError: true,
            message: 'Authentication token refresh failed'
          });
        }
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  authAxios.interceptors.response.use(
    function (response) {
      if (response.status === 401) {
        console.warn('401 Unauthorized response received in auth instance');
        // Let the application handle 401 errors gracefully instead of immediate logout
        return Promise.reject({
          ...response,
          isAuthError: true,
          message: response.data?.message || 'Authentication required'
        });
      }

      return response;
    },
    function (error) {
      if (error.response?.status === 401 || error.status === 401) {
        console.warn('401 Unauthorized error received in auth instance');
        // Let the application handle 401 errors gracefully instead of immediate logout
        return Promise.reject({
          ...error,
          isAuthError: true,
          message:
            error.response?.data?.message ||
            error.message ||
            'Authentication required'
        });
      } else {
        return Promise.reject(error);
      }
    }
  );

  return authAxios;
}

export function createAxiosHeaderlessInstance() {
  let headers = {
    'Content-Type': 'application/json'
  };

  const apiBase = apiConfig.serviceApiCM || apiConfig.serviceApi;

  const authAxios = axios.create({
    baseURL: `${apiBase}${AMLS_COMMON}`,
    timeout: 180000,
    headers: headers
  });

  authAxios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  return authAxios;
}
